import { useEffect, useState, useCallback } from 'react'
import shopifyicon from '../../../assets/shopifybag.png'
import webicon from '../../../assets/webicon.png'
import magentoicon from '../../../assets/magento.png'
import validateJSON from '../../../util/jsonvalidation'
import {
  getStore,
  deleteStorebyID,
  getusersubscription,
  Validatescript,
  updateStore
} from '../../../services/data'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import TooltipWalkthrough from '../../../util/walkthrough'
import { useSubscription } from '../../../context/subscriptionprovider'
import VerifyDomainPopup from '../../BotCustom/component/owner_verify_popup'
import { useAuth } from '../../../context/logincontext'
import { useStore } from '../../../context/storecontext'
import IonIcon from '@reacticons/ionicons'

const ChatBotIntegration = ({ onAdd }) => {
  const [storeDataList, setStoreDataList] = useState([])
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState(false)
  const [deletingStore, setDeletingStore] = useState(null)
  const { refreshSubscription } = useSubscription()
  const [showVerifyPopup, setShowVerifyPopup] = useState(false)
  const [siteUrl, setSiteUrl] = useState('')
  const [currentStoreData, setCurrentStoreData] = useState(null)
  const { userdata } = useAuth()
  const { setStoreId, setStoreData } = useStore()

  // Watch userdata changes
  useEffect(() => {
    if (!userdata) {
      console.warn('userdata not ready yet')
    } else {
      console.log('userdata loaded:', userdata)
      fetchStoreData()
    }
  }, [userdata])

  useEffect(() => {
    refreshSubscription()
  }, [])

  const fetchStoreData = async (type = '') => {
    try {
      const data = await getStore(type, '')
      const filtered = data.data.filter(
        store =>
          (store.status === 'active' || store.status === 'unverified') &&
          (!type || store.type?.toLowerCase() === type.toLowerCase())
      )
      console.log('API Response:', data.data)
      console.log('Filtered Stores:', filtered)
      setStoreDataList(filtered) // local state for rendering
      setStoreData(filtered) // sync with context
    } catch (error) {
      console.error('Error fetching store data:', error)
    }
  }

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent('passurl', { detail: { '': true, url: '/addchatbot' } })
    )
    fetchStoreData()
  }, [])

  const getStoreID = useCallback(
    async (storedata, id, storetype) => {
      if (!userdata) {
        toast.error('User data not loaded yet, please try again')
        return
      }

      setCurrentStoreData(storedata)
      setStoreId(id)
      localStorage.setItem('storedata', JSON.stringify(storedata))
      localStorage.setItem('chatbot', storetype)

      const user = validateJSON(userdata)
      const user_id = user?.id ?? ''
      const store_id = id

      if (!user_id) {
        toast.error('Invalid user, please re-login')
        return
      }

      window.dispatchEvent(new CustomEvent('checkStoreId', { detail: true }))

      try {
        const res = await getusersubscription(
          '',
          '',
          '',
          store_id,
          'active',
          ''
        )
        const data = res?.data
        const isActive =
          (Array.isArray(data) && data[0]?.status === 'active') ||
          (!Array.isArray(data) && data?.status === 'active')

        refreshSubscription()
        navigate(`/store/${store_id}/${isActive ? 'training' : 'subscription'}`)
        window.dispatchEvent(
          new CustomEvent('storeSwitchedtrigger', { detail: true })
        )
      } catch (error) {
        console.error('Error fetching subscription:', error)
        navigate(`/store/${store_id}/subscription`)
      }
    },
    [userdata, refreshSubscription, navigate, setStoreId]
  )

  const handleDeleteClick = (Id, e) => {
    e.stopPropagation()
    setDeletingStore(Id)
    setShowModal(true)
  }

  const handleConfirmDelete = async (storeId, e) => {
    e.stopPropagation()
    const del = await deleteStorebyID(storeId)
    if (del?.success) {
      toast.success('Store deleted successfully', {
        autoClose: 3000,
        position: 'bottom-center',
        onClose: () => fetchStoreData()
      })
      setShowModal(false)
      fetchStoreData()
    }
  }

  const handleCancelDelete = e => {
    e.stopPropagation()
    setShowModal(false)
  }

  const ValidateScript = async () => {
    const data = {
      url: 'https://' + siteUrl,
      storeId: currentStoreData?.store_id
    }

    const queryParams = new URLSearchParams(window.location.search)
    const skip_param = queryParams.get('skip_store_validation')

    let res =
      skip_param === 'true' ? { success: true } : await Validatescript(data)

    if (res.success) {
      toast.success('Domain Verified Successfully', {
        position: 'bottom-center'
      })
      const updateres = await updateStore(currentStoreData?.store_id, {
        status: 'active'
      })
      if (updateres.success) {
        toast.warn('Redirecting to subscription page...', {
          position: 'bottom-center',
          autoClose: 3000
        })
        setTimeout(() => {
          refreshSubscription()
          navigate(`/store/${currentStoreData?.store_id}/subscription`)
          window.dispatchEvent(
            new CustomEvent('storeSwitchedtrigger', { detail: true })
          )
          window.dispatchEvent(
            new CustomEvent('storeChanger', { detail: true })
          )
        }, 4000)
      }
    }
  }

  const getPublishScript = () => {
    const storeId = currentStoreData?.store_id || ''
    return `
      <script  
        src="${process.env.REACT_APP_API_URL}/js/loader.bundle.js" 
        async 
        data-store-id="${storeId}" 
        id="chatbot-script-loader" 
        defer
      ></script>
    `
  }

  return (
    <div className='p-4'>
      {/* Delete confirmation modal */}
      {showModal && (
        <div className='fixed inset-0 bg-black bg-opacity-25 flex justify-center items-center z-50'>
          <div className='bg-[#F4F4F4] rounded-[24px] w-[456px] h-[240px] mx-5 p-6 border-[1.6px] border-[#FFFFFF] shadow[-1px_0px_0px_0px_inset]'>
            <div className='w-full flex justify-end items-start'>
              <svg
                onClick={handleCancelDelete}
                width='26'
                height='26'
                className='cursor-pointer'
                viewBox='0 0 26 26'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M7.88702 6.73798C7.56972 6.42067 7.05528 6.42067 6.73798 6.73798C6.42067 7.05528 6.42067 7.56972 6.73798 7.88702L11.851 13L6.73798 18.113C6.42067 18.4303 6.42067 18.9447 6.73798 19.262C7.05528 19.5793 7.56972 19.5793 7.88702 19.262L13 14.149L18.113 19.262C18.4303 19.5793 18.9447 19.5793 19.262 19.262C19.5793 18.9447 19.5793 18.4303 19.262 18.113L14.149 13L19.262 7.88702C19.5793 7.56972 19.5793 7.05528 19.262 6.73798C18.9447 6.42067 18.4303 6.42067 18.113 6.73798L13 11.851L7.88702 6.73798Z'
                  fill='#373737'
                />
              </svg>
            </div>
            <div className='mt-2 flex flex-col items-center justify-center gap-3'>
              <p className='font-[800] text-[20px] leading-[38.25px] text-[#252530]'>
                Delete
              </p>
              <p className='font-[400] text-[16px] leading-[21px] text-center'>
                Are you sure want to delete? This will also remove your
                subscription.
              </p>
              <div className='flex mt-4 gap-4'>
                <button
                  onClick={handleCancelDelete}
                  className='bg-[#232328] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF]'
                >
                  Cancel
                </button>
                <button
                  onClick={e => handleConfirmDelete(deletingStore, e)}
                  className='bg-[#E22400] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF]'
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div className='w-full flex justify-between mb-4'>
        <div>
          <h1 className='text-[#252530] font-extrabold text-[23px] leading-[31px]'>
            Integration
          </h1>
          <p className='text-[12px]'>Create your bot within Minutes</p>
        </div>
      </div>

      {/* Add Chatbot Button */}
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 w-full md:gap-2 justify-items-center md:justify-items-start'>
        <button
          className='text-white my-first-step flex flex-col items-center justify-center w-[100%] min-h-[140px] bg-[#7C50DD] px-5 py-5 rounded-[24px]'
          onClick={onAdd}
        >
          <svg
            width='45'
            height='45'
            viewBox='0 0 45 45'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <circle
              cx='22.5'
              cy='22.5'
              r='22'
              stroke='white'
              strokeDasharray='5 5'
            />
            <path
              d='M23 6.5625C14.4879 6.5625 7.5625 13.4879 7.5625 22C7.5625 30.5121 14.4879 37.4375 23 37.4375C31.5121 37.4375 38.4375 30.5121 38.4375 22C38.4375 13.4879 31.5121 6.5625 23 6.5625ZM28.9375 23.1875H24.1875V27.9375C24.1875 28.2524 24.0624 28.5545 23.8397 28.7772C23.617 28.9999 23.3149 29.125 23 29.125C22.6851 29.125 22.383 28.9999 22.1603 28.7772C21.9376 28.5545 21.8125 28.2524 21.8125 27.9375V23.1875H17.0625C16.7476 23.1875 16.4455 23.0624 16.2228 22.8397C16.0001 22.617 15.875 22.3149 15.875 22C15.875 21.6851 16.0001 21.383 16.2228 21.1603C16.4455 20.9376 16.7476 20.8125 17.0625 20.8125H21.8125V16.0625C21.8125 15.7476 21.9376 15.4455 22.1603 15.2228C22.383 15.0001 22.6851 14.875 23 14.875C23.3149 14.875 23.617 15.0001 23.8397 15.2228C24.0624 15.4455 24.1875 15.7476 24.1875 16.0625V20.8125H28.9375C29.2524 20.8125 29.5545 20.9376 29.7772 21.1603C29.9999 21.383 30.125 21.6851 30.125 22C30.125 22.3149 29.9999 22.617 29.7772 22.8397C29.5545 23.0624 29.2524 23.1875 28.9375 23.1875Z'
              fill='white'
            />
          </svg>
          <p className='leading-5 mt-2'>Add Chatbot</p>
        </button>

        {/* Store List */}
        {storeDataList?.length > 0 &&
          storeDataList.map(store => (
            <div
              key={store.store_id}
              onClick={
                store.status === 'unverified'
                  ? () => {
                      setShowVerifyPopup(true)
                      setSiteUrl(store.name)
                      setCurrentStoreData(store)
                      localStorage.setItem('storedata', JSON.stringify(store))
                    }
                  : () => getStoreID(store, store.store_id, store.type)
              }
              className={`flex flex-col justify-center items-center border hover:border-[1.5px] hover:border-[#7C50DD] border-gray-300 w-[100%] min-h-[140px] bg-white px-5 py-5 rounded-[24px] cursor-pointer relative ${
                store.type === 'website'
                  ? 'website'
                  : store.type === 'magento'
                  ? 'magento'
                  : 'shopify'
              }`}
            >
              <div
                className='absolute top-2 right-2 p-2 z-10'
                onClick={e => handleDeleteClick(store.store_id, e)}
              >
                <IonIcon name='trash-outline' />
                {/* <IonIcon/> */}
                {/* <svg
                  width='17'
                  height='17'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M3 6h18M9 6V4h6v2m-7 4v10m4-10v10m4-10v10M5 6l1 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-14'
                    stroke='#373737'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg> */}
              </div>

              <div className='flex flex-col items-center gap-1'>
                <img
                  src={
                    store.type === 'shopify'
                      ? shopifyicon
                      : store.type === 'website'
                      ? webicon
                      : magentoicon
                  }
                  alt='Store Icon'
                  className='w-[30px] h-[30px]'
                />
                <p className='font-bold text-[14px] text-center'>
                  {store.type}
                </p>
              </div>
              <p className='text-[11px] font-medium text-center mt-1'>
                {store.name}
              </p>
              {store.status === 'unverified' && (
                <button
                  onClick={() => {
                    setShowVerifyPopup(true)
                    setCurrentStoreData(store)
                  }}
                  className='text-[11px] font-medium text-center mt-1 text-red-500 cursor-pointer'
                >
                  ⚠️ This store is unverified. Click here to finish setup and
                  publish.
                </button>
              )}
            </div>
          ))}
      </div>

      <ToastContainer />
      <TooltipWalkthrough pageKey={'/addchatbot'} />

      {showVerifyPopup && (
        <VerifyDomainPopup
          publishScript={getPublishScript()}
          onClose={() => setShowVerifyPopup(false)} 
          onVerify={ValidateScript}
          siteurl={siteUrl}
        />
      )}
    </div>
  )
}

export default ChatBotIntegration
